module.exports = __webpack_public_path__ + "img/title-01.6663c6ac.png";